import "../css/HomeAboutUs.css";
import ScrollFadeInOutLeft from "../../Animations/AnimationJS/ScrollFadeInOutLeft";
import ScrollFadeInOutRight from "../../Animations/AnimationJS/ScrollFadeInOutRight";
import { Link } from "react-router-dom";

const HomeAboutUs = () => {
  const [ref, fadeLeft] = ScrollFadeInOutLeft();
  const [ref2, fadeRight] = ScrollFadeInOutRight();
  const [ref3, fadeLeft3] = ScrollFadeInOutLeft();

  return (
    <section className="homeAboutUsContainer">
      <div className="homeAUtitle">
        <div className="homeAUtitleGrid">
          <div className="homeAUtitleText">
            <h2 className="largeSentenceAU">
              Alpha 1 Industrial Services is your trusted partner.
            </h2>
            <Link to="/about" className="learnAU">
              Learn more about us
              <span aria-hidden="true">&rarr;</span>
            </Link>
          </div>
          <img
            src="/images/Logos/SmallLogo.png"
            alt="Alpha 1 Industrial Services"
            className="AULogoImage"
          />
        </div>
      </div>

      <div className="homeAUContentGrid">
        <div ref={ref} className={`AUcell AUimg1 ${fadeLeft}`}>
          <img
            src="/images/HomeAUImages/img1.jpg"
            alt="Alpha 1 crew relocating industrial equipment"
            className="AUimg"
          />
        </div>
        <div className="AUcell AUtext1">
          <p className="AUtext">
            Specializing in swift, efficient machine relocation, we pride
            ourselves on eliminating downtime and optimizing speed in every
            move.
          </p>
        </div>

        <div ref={ref2} className={`AUcell AUimg2 ${fadeRight}`}>
          <img
            src="/images/HomeAUImages/img3.jpg"
            alt="Heavy machinery being lifted by Alpha 1"
            className="AUimg"
          />
        </div>
        <div className="AUcell AUtext2">
          <p className="AUtext">
            Building on four generations of expertise, our family-run machine
            moving company combines vast experience with a commitment to
            efficiency, ensuring speedy and seamless relocations every time.
          </p>
        </div>

        <div ref={ref3} className={`AUcell AUimg3 ${fadeLeft3}`}>
          <img
            src="/images/HomeAUImages/img2.jpg"
            alt="Alpha 1 industrial relocation project on site"
            className="AUimg"
          />
        </div>
        <div className="AUcell AUtext3">
          <p className="AUtext">
            Our company excels in adapting to diverse situations and
            problem-solving, ensuring efficient and tailored solutions for every
            unique relocation challenge.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HomeAboutUs;
